<div class="modal fade" id="kt_modal_vh_inventory_detail" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header d-flex justify-content-between align-items-center">
        <h2 class="fw-bold m-0" style="color: #181c32;">
          <i class="ki-duotone ki-car fs-2 me-2">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
          Vehicle Inventory Details
        </h2>
        <button type="button" class="btn btn-icon btn-sm btn-active-icon-light ms-auto" data-bs-dismiss="modal" aria-label="Close">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body p-0">
        <!-- Loading State -->
        <div *ngIf="isLoading" class="text-center py-10">
          <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-3 text-muted fs-5">Loading vehicle details...</p>
        </div>

        <!-- Vehicle Details -->
        <div *ngIf="!isLoading && vehicle" class="p-6">
          <!-- Vehicle Header Info -->
          <div class="row mb-6">
            <div class="col-12">
              <div class="card">
                <div class="card-body p-4">
                  <div class="row align-items-center">
                    <div class="col-md-12">
                      <h3 class="fw-bold mb-2" style="color: #181c32;">
                        {{ getDisplayValue(vehicle.name, 'Vehicle Name Not Available') }}
                      </h3>
                      <p class="text-muted mb-0">
                        <strong>Stock Number:</strong> {{ getDisplayValue(vehicle.car_no || vehicle.stock_no) }} |
                        <strong>Make:</strong> {{ getDisplayValue(vehicle.company_name) }} |
                        <strong>Model:</strong> {{ getDisplayValue(vehicle.name) }} |
                        <strong>Year:</strong> {{ getDisplayValue(vehicle.year) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Vehicle Details Grid -->
          <div class="row">
            <!-- Basic Information Section -->
            <div class="col-12 mb-6">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title fw-bold text-dark">
                    <i class="ki-duotone ki-information fs-2 me-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                    </i>
                    Basic Information
                  </h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Book Req. Rate</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.book_req_rate) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Booking Status</label>
                      <div class="form-control-plaintext">
                        <span class="badge badge-light-info">{{ getDisplayValue(vehicle.booking_status, 'Pending') }}</span>
                      </div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Buyer Name</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(getDisplayValue(vehicle.invoice?.order?.buyer_consignee_name)) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Car Category</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.category_name || vehicle.car_category) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">CC</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.engine || vehicle.engine_cc) }} CC</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Chassis Number</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.vin_no || vehicle.chassis_no) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Color</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.color || vehicle.exterior_color) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Doors</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.doors) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Drive</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.drive || vehicle.steering) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Engine Model</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.engine_model || vehicle.engine) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Fuel</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.fuel_type) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Mileage (km)</label>
                      <div class="form-control-plaintext fw-bold">{{ formatMileage(vehicle.mileage) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Consignee Information Section -->
            <div class="col-12 mb-6">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title fw-bold text-dark">
                    <i class="ki-duotone ki-profile-user fs-2 me-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                    </i>
                    Consignee Information
                  </h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Consignee Name</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.order?.buyer_consignee_name) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Consignee Email</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.order?.buyer_email_address) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Consignee Tel</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.order?.buyer_telephone_no) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Consignee Tel 2</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.order?.buyer_telephone_no_2) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Consignee City</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.order?.buyer_city) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Consignee Country</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.order?.buyer_country) }}</div>
                    </div>
                    <div class="col-md-12 mb-4">
                      <label class="form-label fw-semibold text-muted">Consignee Address</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.order?.buyer_street_address) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Shipping Information Section -->
            <div class="col-12 mb-6">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title fw-bold text-dark">
                    <i class="ki-duotone ki-delivery fs-2 me-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                      <span class="path5"></span>
                    </i>
                    Shipping Information
                  </h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Container Number</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.ship?.container_number) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">CTN Group No.</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.order?.group_no) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Departing Port</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.ship?.sailing_port) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Sailing Country</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.ship?.sailing_port) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Ship Name</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.ship?.name) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Ship Type</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.order?.ship_type) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Shipping Company</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.ship?.company) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Voyage No</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.invoice?.ship?.voyage_no) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">ETA</label>
                      <div class="form-control-plaintext fw-bold">{{ formatDate(vehicle.invoice?.ship?.arrival_date) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">ETD</label>
                      <div class="form-control-plaintext fw-bold">{{ formatDate(vehicle.invoice?.ship?.sailing_date) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Master BOL No (BL Number)</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.master_bol_no || vehicle.bl_number) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Masho Date</label>
                      <div class="form-control-plaintext fw-bold">{{ formatDate(vehicle.masho_date) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Vehicle Specifications Section -->
            <div class="col-12 mb-6">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title fw-bold text-dark">
                    <i class="ki-duotone ki-setting-2 fs-2 me-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                    Vehicle Specifications
                  </h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Height (cm)</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.car_height) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Length (cm)</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.car_length) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Width (cm)</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.car_width) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Weight (kg)</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.weight_kg) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Lead Capacity (kg)</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.lead_capacity_kg) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">M3</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.m3) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Seat</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.seats) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Steering</label>
                      <div class="form-control-plaintext fw-bold" style="text-transform: capitalize;">{{ getDisplayValue(vehicle.steering) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Transmission</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.transmission) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Model Code</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.model_code) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Mfg Month</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.mfg_month) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Mfg Year</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.year) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Reg Month</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.reg_month) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Auction & Lot Information Section -->
            <div class="col-12 mb-6">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title fw-bold text-dark">
                    <i class="ki-duotone ki-chart-simple fs-2 me-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                    </i>
                    Auction & Lot Information
                  </h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Lot Number</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.lot_no) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Est Grade</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.est_grade) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Maker Grade</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.maker_grade) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Sold Date</label>
                      <div class="form-control-plaintext fw-bold">{{ formatDate(vehicle.sold_date) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Inspection & Status Section -->
            <div class="col-12 mb-6">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title fw-bold text-dark">
                    <i class="ki-duotone ki-verify fs-2 me-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                    Inspection & Status
                  </h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Insp. Date</label>
                      <div class="form-control-plaintext fw-bold">{{ formatDate(vehicle.insp_date) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Insp. Status</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.insp_status) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Report Date</label>
                      <div class="form-control-plaintext fw-bold">{{ formatDate(vehicle.report_date) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Yard In Date</label>
                      <div class="form-control-plaintext fw-bold">{{ formatDate(vehicle.yard_in_date) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Yard</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.yard) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Sales Agent</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.sales_agent) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Terms</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.terms) }}</div>
                    </div>
                    <div class="col-md-3 mb-4">
                      <label class="form-label fw-semibold text-muted">Currency</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.currency) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Notify Party Information Section -->
            <div class="col-12 mb-6">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title fw-bold text-dark">
                    <i class="ki-duotone ki-notification-bing fs-2 me-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                    </i>
                    Notify Party Information
                  </h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Notify Party Name</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.notify_party_name) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Notify Party Email</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.notify_party_email) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Notify Party Tel.1</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.notify_party_tel_1) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Notify Party City</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.notify_party_city) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Notify Party Country</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.notify_party_country) }}</div>
                    </div>
                    <div class="col-md-12 mb-4">
                      <label class="form-label fw-semibold text-muted">Notify Party Address 1</label>
                      <div class="form-control-plaintext fw-bold">{{ getDisplayValue(vehicle.notify_party_address_1) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Financial Information Section -->
            <div class="col-12 mb-6">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title fw-bold text-dark">
                    <i class="ki-duotone ki-dollar fs-2 me-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                    </i>
                    Financial Information
                  </h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <!-- Auction Prices -->
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Auction Price</label>
                      <div class="form-control-plaintext fw-bold text-success">{{ formatPrice(vehicle.price_sheet?.description?.auction_price?.actual) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Auc Price Tax</label>
                      <div class="form-control-plaintext fw-bold text-warning">{{ formatPrice(vehicle.price_sheet?.description?.auction_price_tax?.actual) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Auction Price + Tax</label>
                      <div class="form-control-plaintext fw-bold text-success">{{ formatPrice(getTotalAuctionPrice(vehicle.price_sheet)) }}</div>
                    </div>

                    <!-- Bid Charges -->
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Bid Charge</label>
                      <div class="form-control-plaintext fw-bold text-info">{{ formatPrice(vehicle.price_sheet?.description?.bid_charge?.actual) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Bid Charge Tax</label>
                      <div class="form-control-plaintext fw-bold text-warning">{{ formatPrice(vehicle.price_sheet?.description?.bid_price_tax?.actual) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Bid Charge + Tax</label>
                      <div class="form-control-plaintext fw-bold text-info">{{ formatPrice(getTotalBidCharge(vehicle.price_sheet)) }}</div>
                    </div>

                    <!-- Transport Charges -->
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">1st Transport Charge</label>
                      <div class="form-control-plaintext fw-bold" style="color: #7e8299;">{{ formatPrice(vehicle.price_sheet?.local_transport_rikuso?.first_transport_charge?.actual) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">2nd Transport Charge</label>
                      <div class="form-control-plaintext fw-bold" style="color: #7e8299;">{{ formatPrice(vehicle.price_sheet?.local_transport_rikuso?.second_transport_charge?.actual) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">3rd Transport Charge</label>
                      <div class="form-control-plaintext fw-bold" style="color: #7e8299;">{{ formatPrice(vehicle.price_sheet?.local_transport_rikuso?.third_transport_charge?.actual) }}</div>
                    </div>

                    <!-- Other Financial Fields -->
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Freight Amount</label>
                      <div class="form-control-plaintext fw-bold">{{ formatPrice(vehicle.price_sheet?.shipping_costs?.freight_rate?.actual) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Inv Balance Amount</label>
                      <div class="form-control-plaintext fw-bold">{{ formatPrice(+vehicle.invoice?.balance) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Inv Total</label>
                      <div class="form-control-plaintext fw-bold">{{ formatPrice(+vehicle.invoice?.invoice_amount) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Paid Amount</label>
                      <div class="form-control-plaintext fw-bold text-info">{{ formatPrice(+vehicle.invoice?.paid) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Recycle Fees Paid</label>
                      <div class="form-control-plaintext fw-bold">{{ formatPrice(vehicle.price_sheet?.refunds?.recycle_fee_paid?.actual) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Total Cost</label>
                      <div class="form-control-plaintext fw-bold text-warning">{{ formatPrice(vehicle.total_cost) }}</div>
                    </div>
                    <div class="col-md-4 mb-4">
                      <label class="form-label fw-semibold text-muted">Selling Price</label>
                      <div class="form-control-plaintext fw-bold text-primary">{{ formatPrice(vehicle.price_sheet?.description?.selling_price?.actual) }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Error State -->
        <div *ngIf="!isLoading && !vehicle" class="text-center py-10">
          <div class="text-gray-400 fs-1 mb-3">
            <i class="ki-duotone ki-information fs-3x">
              <span class="path1"></span>
              <span class="path2"></span>
              <span class="path3"></span>
            </i>
          </div>
          <h3 class="text-gray-800 fs-2 fw-bold mb-3">Vehicle details not found</h3>
          <p class="text-gray-400 fs-6 mb-0">Unable to load vehicle information</p>
        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer" *ngIf="!isLoading">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-2 me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          Close
        </button>
      </div>
    </div>
  </div>
</div>
